// src/helpers/notifications/templates/updates.ts
import moment from 'moment';
import { TemplateMeta } from '../notificationConfig';
import { formatReadableDate } from 'helpers/date';

export const updatesManualTemplates: TemplateMeta[] = [
    {
        key: 'profile.updated',
        label: 'Profile Updated',
        type: 'updates',
        icon: 'ri-user-settings-line text-secondary',
        title: () => `Your profile was updated`,
        subtitle: d => `Changes: ${d.fields_changed}`,
    },
    {
        key: 'password.changed',
        label: 'Password Changed',
        type: 'updates',
        icon: 'ri-lock-password-line text-danger',
        title: () => `Your password was changed`,
        subtitle: () => `Ensure it’s secure`,
    },
    {
        key: 'subscription.renewed',
        label: 'Subscription Renewed',
        type: 'updates',
        icon: 'ri-vip-crown-line text-warning',
        title: () => `Subscription renewed`,
        subtitle: d => `Valid through ${formatReadableDate(d.expiry_date)}`,
    },
    {
        key: 'feature.available',
        label: 'New Feature Available',
        type: 'updates',
        icon: 'ri-rocket-line text-success',
        title: d => `New feature available: ${d.feature_name}`,
    },
    {
        key: 'bulk.updated',
        label: 'Bulk Update',
        type: 'updates',
        icon: 'ri-pencil-line text-success',
        title: d => `Bulk record updated successfully`,
    },
    {
        key: 'bulk_update.success',
        label: 'Bulk Update Successful',
        type: 'updates',
        icon: 'ri-loop-right-line text-success',
        title: d => `Bulk Update Successful`,
        subtitle: d => d.start_time ? `Process completed on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}` : '',
    },
    {
        key: 'bulk_update.fail',
        label: 'Bulk Update Failed',
        type: 'updates',
        icon: 'ri-loop-right-line text-danger',
        title: d => `Bulk Update Failed`,
        subtitle: d => d.times ? `Process failed on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}` : '',
    },
    {
        key: 'bulk_update.start',
        label: 'Bulk Update Started',
        type: 'updates',
        icon: 'ri-loop-right-line text-info',
        title: d => `Bulk Update Started`,
        subtitle: d => d.start_time ? `Process started on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}` : '',
    },
    {
        key: 'export_file.success',
        label: 'Export Successful',
        type: 'updates',
        icon: 'ri-share-forward-line text-success',
        title: d => `Export Successful`,
        subtitle: d => d.start_time ? `Export completed on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}
        <a class="text-primary">Click here</a>` : '',
    },
    {
        key: 'export_file.fail',
        label: 'Export Failed',
        type: 'updates',
        icon: 'ri-share-forward-line text-danger',
        title: d => `Export Failed`,
        subtitle: d => d.times ? `Export failed on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}
  <a class="text-primary">Click here</a>` : '',
    },
    {
        key: 'export_file.start',
        label: 'Export Started',
        type: 'updates',
        icon: 'ri-share-forward-line text-info',
        title: d => `Export Started`,
        subtitle: d => d.start_time ? `Export started on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}
        <a class="text-primary">Click here</a>` : '',
    },
    {
        key: 'bulk_delete.success',
        label: 'Bulk Delete Successful',
        type: 'updates',
        icon: 'ri-delete-bin-line text-success',
        title: d => `Bulk Delete Successful`,
        subtitle: d => d.start_time
            ? `Process completed on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}`
            : '',
    },
    {
        key: 'bulk_delete.fail',
        label: 'Bulk Delete Failed',
        type: 'updates',
        icon: 'ri-delete-bin-line text-danger',
        title: d => `Bulk Delete Failed`,
        subtitle: d => d.start_time
            ? `Process failed on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}`
            : '',
    },
    {
        key: 'bulk_delete.start',
        label: 'Bulk Delete Started',
        type: 'updates',
        icon: 'ri-delete-bin-line text-info',
        title: d => `Bulk Delete Started`,
        subtitle: d => d.start_time
            ? `Process started on ${moment(d.start_time).format('D MMM YYYY, h:mm A')}`
            : '',
    },
];
